import apiClient from './ApiService'

export default {
  getFederaciones(page = 1, limit = 15, filters = {}) {
    return apiClient.get('/federaciones', {
      params: {
        page,
        limit,
        ...filters
      }
    })
  },
  
  getFederacion(id) {
    return apiClient.get(`/federaciones/${id}`)
  },
  
  createFederacion(federacion) {
    return apiClient.post('/federaciones', federacion)
  },
  
  updateFederacion(id, federacion) {
    return apiClient.put(`/federaciones/${id}`, federacion)
  },
  
  deleteFederacion(id) {
    return apiClient.delete(`/federaciones/${id}`)
  },
  
  exportarListado(formato, filtros = {}) {
    return apiClient.get('/federaciones/exportar', {
      params: {
        formato,
        ...filtros
      },
      responseType: 'blob'
    })
  }
}